import React from 'react';
import { Modal, Typography, Divider, Timeline } from 'antd';

const { Title } = Typography;

const HistoryModal = ({ isVisible, onClose, selectedProduct }) => {
  return (
    <Modal
      title="Istoric Produs"
      open={isVisible}
      onCancel={onClose}
      footer={null}
    >
      {selectedProduct && (
        <div>
          <Title level={5}>{selectedProduct.product?.denumire}</Title>
          <Divider />
          <Timeline>
            <Timeline.Item>Produs adăugat în sistem</Timeline.Item>
            <Timeline.Item>Comandă inițiată</Timeline.Item>
            <Timeline.Item>Comandă confirmată</Timeline.Item>
          </Timeline>
        </div>
      )}
    </Modal>
  );
};

export default HistoryModal; 